import Form from './Form';
import Message from './Message';

/*
* Custom Javascript
 */
import ContactForm from './ContactForm';
import Navigation from './Navigation';

let App = {
    init() {
        window.Form = new Form();
        $('body').removeClass('loading');
        window.Message = new Message();
    }
};

/**
 * Begin app gracefully
 */
// Create app window
function startApp() {
    if (!window.appStarted) {
        window.App = App;
        window.App.init();
        window.appStarted = true;
    }
}
// Start app on window load or 2s after the DOM is ready
$(window).on('load', () => {
    startApp();
});
$(document).on('ready', () => {
    setTimeout( () => {
        startApp();
    }, 2000);
});


// WEBPACK FOOTER //
// ./resources/assets/js/App.js